import React from "react";

const BuyNodeMessage = ({ messageText }) => {
  return (
    <tr>
      <td
        colSpan="5"
        className="text-center flex justify-center items-start py-[30px] text-sm leading-6 text-lightBlack dark:text-semiWhite"
      >
        {`Buy XBR Founder’s Node to see your ${messageText}`}
      </td>
    </tr>
  );
};

export default BuyNodeMessage;
